import Vue from 'vue';

export default {
    // Busca todos os checklists
    listarTodos() {
        return Vue.prototype.$http.get('/checklist');
    },

    // Cria um novo checklist
    criar(payload) {
        return Vue.prototype.$http.post('/checklist', payload);
    },

    // Busca detalhes de um checklist específico
    buscarPorId(id) {
        return Vue.prototype.$http.get(`/checklist/${id}`);
    },

    // Busca o �ltimo checklist de um local (bloco, andar, sala)
    buscarUltimoPorLocal(idBloco, idAndar, idSala) {
        let url = `/checklist/ultimo-por-local?bloco=${idBloco}`;
        if (idAndar) url += `&andar=${idAndar}`;
        if (idSala) url += `&sala=${idSala}`;
        return Vue.prototype.$http.get(url);
    },

    // Altera o status do checklist (Ex: 'Ini', 'Fin', 'Can')
    mudarStatus(id, status) {
        return Vue.prototype.$http.put(`/checklist/${id}/status`, { status });
    },

    // Autoriza um checklist
    autorizar(id) {
        return Vue.prototype.$http.put(`/checklist/${id}/autorizar`, { autorizado: true });
    },
    
    // Define se o checklist é âncora
    definirAncora(id, isAncora) {
        return Vue.prototype.$http.put(`/checklist/${id}/ancora`, { ancora: isAncora });
    },

    // Atualiza a quantidade de um item do checklist
    atualizarItemQuantidade(idChecklistItem, quantidade) {
        return Vue.prototype.$http.put(`/checklist/item/${idChecklistItem}/quantidade`, { quantidade: parseInt(quantidade, 10) || 0 });
    },

    // Atualiza se um item do checklist tem problema
    atualizarItemProblema(idChecklistItem, problema) {
        return Vue.prototype.$http.put(`/checklist/item/${idChecklistItem}/problema`, { problema: Boolean(problema) });
    },

    // Atualiza a observação de um item do checklist
    atualizarItemObservacao(idChecklistItem, observacao) {
        return Vue.prototype.$http.put(`/checklist/item/${idChecklistItem}/observacao`, { observacao });
    }
};

